import { Component, Input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { WafProfileMinimal } from '@bn/app-shield';
import { DashboardSharedModule } from '@bn/dashboard-shared';
import { LazyLoadDirective } from '@bn/web-ui';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { TabItem } from '@bn/web-ui/tabs/models';
import { TabsComponent } from '@bn/web-ui/tabs/tabs.component';

@Component({
  selector: 'app-shield-setup-platform',
  templateUrl: './app-shield-setup-platform.component.html',
  styleUrls: ['./app-shield-setup-platform.component.scss'],
  imports: [CardComponent, DashboardSharedModule, FaIconComponent, LazyLoadDirective, NgxSkeletonLoaderComponent, TabsComponent],
})
export class AppShieldSetupPlatformComponent {
  @Input()
  public set setShieldProfiles(shieldProfiles: WafProfileMinimal[]) {
    if (shieldProfiles?.length > 0) {
      this.profiles = shieldProfiles;
      this.filteredProfiles = this.profiles;
      this.setProfileCategories(shieldProfiles);
      this.isLoading = false;
    }
  }

  @Input()
  public selectedProfileId?: number | null = null;

  public readonly profileCategories: TabItem[] = [
    {
      name: 'All',
      tooltip: 'All Platforms',
    },
  ];

  public selectedTab: TabItem;

  public profiles!: WafProfileMinimal[];
  public filteredProfiles?: WafProfileMinimal[];

  public selectedProfileCategory!: string;

  public readonly selectShieldProfile = output<number>();

  public isLoading = true;
  constructor() {
    this.selectedTab = this.profileCategories[0];
  }

  public setProfileCategories(profiles: WafProfileMinimal[]) {
    const categories = profiles.map((profile) => profile.profileCategory).filter((category) => category !== '');
    const uniqueCategories = Array.from(new Set(categories));

    uniqueCategories.forEach((category) => {
      this.profileCategories.push({ name: category ?? undefined, title: category ?? undefined });
    });
  }

  public onActiveTabChange(tab: number) {
    this.selectedTab = this.profileCategories[tab];
    this.selectedProfileCategory = this.selectedTab.name ?? '';

    if (this.selectedProfileCategory && this.selectedProfileCategory !== 'All') {
      this.filteredProfiles = this.profiles.filter((profile) => profile.profileCategory === this.selectedProfileCategory);
    } else {
      this.filteredProfiles = this.profiles;
    }
  }

  public onProfileSelect(id: WafProfileMinimal['id']) {
    this.selectedProfileId = id;
    this.selectShieldProfile.emit(this.selectedProfileId || 0);
  }
}
